module.exports = __webpack_public_path__ + "img/doc.24b84366.svg";